import Axios from 'axios';
import React, { useEffect, useState } from 'react';

function TestPage() {

    const [TimeCount, setTimeCount] = useState(60);
    const REDIRECT_URI = window.location.origin + '/body-profile';
    // const REDIRECT_URI = '';//위의 페이지 무한 재로딩 현상을 막기 위한 임시 주소

    const getKakaoToken = async (code) => {
        await fetch("https://kauth.kakao.com/oauth/token", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: `grant_type=authorization_code&client_id=${process.env.REACT_APP_KEY_KAKAO_REST}&redirect_uri=${REDIRECT_URI}&code=${code}`,
        })
            .then((res) => res.json())
            .then((data) => {
                // // OIDC 사용하는 경우 id_token으로 접근해야 한다.
                // if (data.id_token) {
                //     setIdToken(data.id_token);
                // } else {
                //     console.log('id_token 없음 :', data);
                // }

                if (data.access_token) {
                    window.Kakao.Auth.setAccessToken(data.access_token);

                    window.Kakao.API.request({
                        url: '/v2/user/me',
                    }).then(function (response) {
                        Axios.post('/api/log', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            url: window.location.href,
                            data: response,
                        }).then((response) => {
                            //console.log('response:', response);
                        }).catch((error) => {
                            console.log('error:', error);
                        });
                    }).catch(function (error) {
                        console.log('catch:', error);
                        alert(error);
                    });
                }
                else {
                    console.log('access_token 없음 :', data);
                }

            })
            .catch((error) => {
                console.log('error:', error);
            });
    };


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        //KAKAO REST API 에 code 보내서 토큰 받아오기
        if (code) {
            getKakaoToken(code);
        }
        else {
            window.Kakao.Auth.authorize({
                redirectUri: REDIRECT_URI,
                // prompt: 'none',//자동로그인 모드 - 여러 상황에서 무한 루프 오류 발생
            });
        }

        const countdownTimer = setInterval(() => {
            setTimeCount((prevTimeCount) => {
                if (prevTimeCount <= 1) {
                    clearInterval(countdownTimer);
                    console.log('Time out');
                    return 0;
                }
                console.log('start timer :', prevTimeCount - 1);
                return prevTimeCount - 1;
            });
        }, 1000);

        return () => {
            clearInterval(countdownTimer);
        }
    }, []);


    return (
        <div className='page'>
            바디 프로필 목록 로딩 중...
            <br />
            Time Limit : {TimeCount}
        </div>
    )
}

export default TestPage;